import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	codeContent: {
		id: 'servicedesk-customer-notification-settings-templates.code-mirror-wrapper.code-content',
		defaultMessage: 'Code Content',
		description: 'Content for Code',
	},
});
